import colors from '~/assets/tailwindColors.json'

export function useProseTheme (techId, level = 'junior') {
  const techProseColors = {
    vuejs: {
      junior: {
        bg: '#2b423b',
        text: '#979FAD'
      },
      senior: {
        bg: '#2b423b',
        text: '#979FAD'
      }
    },
    nuxt: {
      junior: {
        bg: '#2b423b',
        text: '#979FAD'
      },
      senior: {
        bg: '#2b423b',
        text: '#979FAD'
      }
    },
    angular: {
      junior: {
        bg: colors['angular-pink'] + '33',
        text: '#fff'
      },
      intermediate: {
        bg: colors['angular-purple'] + '33',
        text: '#fff'
      },
      senior: {
        bg: colors['angular-mint'] + '33',
        text: '#fff'
      }
    },
    javascript: {
      junior: {
        bg: colors['js-yellow'].replace('<alpha-value>', '0.33'),
        text: '#000'
      },
      intermediate: {
        bg: colors['js-magenta'].replace('<alpha-value>', '0.33'),
        text: '#fff'
      },
      senior: {
        bg: colors['js-mint'].replace('<alpha-value>', '0.33'),
        text: '#fff'
      }
    },
    react: {
      junior: {
        bg: colors['react-blue'].replace('<alpha-value>', '0.33'),
        text: '#000'
      },
      intermediate: {
        bg: colors['react-orange'].replace('<alpha-value>', '0.33'),
        text: '#fff'
      },
      senior: {
        bg: colors['react-green'].replace('<alpha-value>', '0.33'),
        text: '#fff'
      }
    }
  }

  const selectedTheme = computed(() => techProseColors?.[techId]?.[level])

  onMounted(() => {
    const root = document.body

    if (selectedTheme.value) {
      root.style.setProperty('--color-prose-bg', selectedTheme.value?.bg)
      root.style.setProperty('--color-prose-text', selectedTheme.value?.text)
    }
  })
  return techProseColors
}
